module.exports = __webpack_public_path__ + "static/media/mobility_too_high.6593fa3c.png";